import { MaskedLine, FadeIn } from "@/components/Reveal";

const PageHero = ({ eyebrow, title, italic, description, image, imageAlt = "Luxury hotel interior with premium hospitality textiles" }) => (
  <section data-testid="page-hero" className="relative min-h-[62vh] flex items-end overflow-hidden bg-navy">
    <div className="absolute inset-0">
      <img src={image} alt={imageAlt} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-navy/60" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
    </div>
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pb-20 pt-44 w-full">
      <FadeIn delay={0.2}>
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-10 bg-gold" />
          <span className="text-[11px] tracking-[0.32em] uppercase text-ivory/70">{eyebrow}</span>
        </div>
      </FadeIn>
      <h1 className="font-serif font-medium tracking-tight text-5xl sm:text-6xl md:text-7xl text-ivory leading-[1.02] max-w-4xl">
        <MaskedLine delay={0.3}>{title}</MaskedLine>
        {italic && (
          <MaskedLine delay={0.45}>
            <span className="italic text-gold">{italic}</span>
          </MaskedLine>
        )}
      </h1>
      {description && (
        <FadeIn delay={0.7}>
          <p className="mt-6 text-ivory/75 text-base md:text-lg font-light max-w-2xl leading-relaxed">
            {description}
          </p>
        </FadeIn>
      )}
    </div>
  </section>
);

export default PageHero;
